import { requestParamsImpl } from "../services/request-params.service";
import { config } from "../config";

export const buildRouteWithParams = (
  route: string,
  displayQuery: boolean = true
): string => {
  const { referralKey, restaurantId, version, bookingToken, bookingId } =
    requestParamsImpl.requestParams;
  let baseApiUrl = version
    ? `${config.routes.base}/${version}`
    : config.routes.base;
  let redirectUrl = `${baseApiUrl}`;
  if (restaurantId) {
    redirectUrl += `/${restaurantId}`;
  }
  redirectUrl += `/${referralKey}/${route}`;
  // if (displayQuery && bookingToken && bookingId) {
  //   redirectUrl += `?booking_token=${bookingToken}&booking_id=${bookingId}`;
  // }

  let searchQuery = requestParamsImpl.computeSearchQueryForOverwrittenParams();
  if (searchQuery && displayQuery && config.routes.selection === route)
    redirectUrl += `${searchQuery}`;
  return redirectUrl;
};
